// extracted by mini-css-extract-plugin
module.exports = {"root":"_179368e207b2e1cfd3b850ccdcee09fe","bg":"d49f94b57277136c8530a41e6268dfd7","svg":"ea83180d3707bb714bae024f9f09e531","title":"_63369a6fda5af064b9948489d34dc415"};